import React from 'react'
import { Modal, View, StyleSheet } from 'react-native'

import { useTranslation } from 'react-i18next'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { PreviewFallback } from './PreviewFallback'
import Button from '../../../components/Button'
import PickerModal from '../../../components/PickerModal'
import Separator from '../../../components/Separator'
import Typography from '../../../components/Text/Typography'
import appStyles from '../../../styles/app-styles'
import Colors from '../../../styles/Colors'

type Props = {
  isVisible: boolean
  onRequestClose: () => void
  onConfirmPress: () => void
}
export function PreviewRegenerateConfirmationModal({
  isVisible,
  onRequestClose,
  onConfirmPress,
}: Props) {
  const insets = useSafeAreaInsets()
  const { t, i18n } = useTranslation(undefined, {
    keyPrefix: 'screens.ebookPreview',
  })

  return (
    <Modal
      transparent
      statusBarTranslucent
      visible={isVisible}
      animationType="fade"
      onRequestClose={onRequestClose}>
      <PickerModal close={onRequestClose}>
        <View style={styles.contentContainer}>
          <Separator height={20} />
          <View style={styles.iconHolder}>
            <PreviewFallback
              maxWidth={200}
              contentColor={Colors['layout.light']}
              backgroundColor={Colors['layout.gray']}
            />
          </View>
          <Separator height={10} />
          <Typography weight="medium" style={styles.title}>
            {t('regenerateModal.title')}
          </Typography>
          <Separator height={5} />
          <Typography style={styles.message}>
            {t('regenerateModal.message')}
          </Typography>
          <Separator height={50} />
          <Button text={t('regenerate')} onPress={onConfirmPress} />
          <Separator height={10} />
          <Button
            type="secondary"
            text={i18n.t('common.cancel')}
            onPress={onRequestClose}
          />
          <Separator height={insets.bottom} />
        </View>
      </PickerModal>
    </Modal>
  )
}

const styles = StyleSheet.create({
  contentContainer: {
    ...appStyles.horizontalCenter,
    padding: 20,
  },
  iconHolder: {
    width: 100,
    aspectRatio: Math.SQRT1_2,
  },
  title: {
    fontSize: 20,
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
  },
})
